import { render, staticRenderFns } from "./PageTrackDelivery.vue?vue&type=template&id=2e1f21e0&scoped=true&"
import script from "./PageTrackDelivery.vue?vue&type=script&lang=ts&"
export * from "./PageTrackDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./PageTrackDelivery.vue?vue&type=style&index=0&id=2e1f21e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f21e0",
  null
  
)

export default component.exports